// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { externalScreenHandler } from "../../Utils/AppHandlers.js";
import { CustomEvent } from "../../Utils/CustomEvents.js";
import { DirectMessageCode } from "../../Utils/DirectMessages/DirectMessagesImport.ts";

export let ExternalLink = function (message)
{
    this.id = null;
    this.name = null;
    this.externalResource = null;   // тип линки из ExternalLink.ExternalLinkType

    this.url = null;
    this.useInternalBrowser = null;

    this.onAvailableUntilExpired = new CustomEvent();
    this.availableUntilExpiredTimeoutID = null;         // тут сохраняем id setTimeout-а, очищаем по нему в случае апдейта availableUntil (на дан.момент поле availableUntil есть только у линков с externalResource == ExternalLink.ExternalLinkType.YOUTUBE_LINK #114288) 

    this.onStreamNeedUpdate = new CustomEvent();
    this.onStreamNeedUpdateTimeoutID = null;         // тут сохраняем id setTimeout-а, очищаем по нему в случае апдейта линки (на дан.момент поле availableUntil есть только у линков с externalResource == ExternalLink.ExternalLinkType.YOUTUBE_LINK #114288) 

    // + поля в зависимости от типа линки приходящие в msg.ExternalLinkParameters

    this.UpdateByMessage(message)
}

ExternalLink.prototype.UpdateByMessage = function (msg)
{
    if (!msg || msg.Code != DirectMessageCode.CODE_PFIX_EXTERNAL_LINK_MESSAGE)
        return

    const oldAvailableUntil = this.availableUntil;

    this.id = msg.Id;
    this.name = msg.Name;

    this.url = msg.Url;
    this.useInternalBrowser = msg.UseInternalBrowser;

    this.externalResource = msg.ExternalResource;

    let externalLinkParameters = JSON.parse(msg.ExternalLinkParameters);

    for (let key in externalLinkParameters)
        this[key] = externalLinkParameters[key]

    if (this.availableUntil && this.availableUntil != oldAvailableUntil)
        this.setTimeoutOnExpirationOfAvailableUntil();

    if (this.accountType)
        this.accountType = ExternalLink.AccountType[this.accountType]
}

ExternalLink.prototype.HasTabSetting = function ()      // для этих типов ссылок можно указать в какую вкладку она будет положена
{
    let type = this.externalResource,
        allTypes = ExternalLink.ExternalLinkType,
        typesAllowTabChoise = [allTypes.NONE, allTypes.LINK_TOKEN_LANG, allTypes.AUTOCHARTIST_IFRAME],
        allowTabChoise = typesAllowTabChoise.indexOf(type) != -1

    return allowTabChoise
}

ExternalLink.prototype.GetEventOnClick = function (mainWindow)    
{
    mainWindow = mainWindow || App.mainWindow

    let tool = this

    let eventOnLinkClick = tool.IsAutochartistIFrameLink() ? mainWindow.openAutochartistIFrame.bind(mainWindow, tool) :
        function ()
        {
            let scr = externalScreenHandler.Show(mainWindow.ExternalScreenStorage.GetToolData(tool.id), tool.IsNoneLink())
        }

    return eventOnLinkClick
}

ExternalLink.prototype.Copy = function ()
{
    let link = new ExternalLink()

    for (let key in this)
        link[key] = this[key]

    return link
}

ExternalLink.prototype.IsNoneLink = function ()      
{
    return this.externalResource === ExternalLink.ExternalLinkType.NONE
}

ExternalLink.prototype.IsAutochartistIFrameLink = function ()      
{
    return this.externalResource == ExternalLink.ExternalLinkType.AUTOCHARTIST_IFRAME
}

ExternalLink.prototype.IsStillAvailable = function ()      
{
    const linkInstance = this;
    const availableUntil = linkInstance.availableUntil;
    if (!availableUntil)
        return null;

    const willBecomeExpiredAfterMS = availableUntil - Date.now();
    return willBecomeExpiredAfterMS > 0;
}

ExternalLink.prototype.setTimeoutOnExpirationOfAvailableUntil = function ()     
{
    const linkInstance = this;
    const availableUntil = linkInstance.availableUntil;
    if (!availableUntil)
        return;

    if (linkInstance.availableUntilExpiredTimeoutID)
        clearTimeout(linkInstance.availableUntilExpiredTimeoutID)

    const willBecomeExpiredAfterMS = availableUntil - Date.now();

    if (willBecomeExpiredAfterMS > 0)
        linkInstance.availableUntilExpiredTimeoutID = setTimeout(() =>
        {
            linkInstance.availableUntilExpiredTimeoutID = null;

            linkInstance.onAvailableUntilExpired.Raise(linkInstance);
        }, willBecomeExpiredAfterMS);
}

const UPDATE_LIVE_TIMEOUT_MS = 300000;  // need update live streams every 10 minutes -> update every 5 min to get fresh data every 10 min

ExternalLink.prototype.setLIVEUpdateTimeout = function (startStreamUpdate = false, cacheItem, eventOnUpdate)
{
    const linkInstance = this;
    if (!linkInstance)
        return;

    if (linkInstance.onStreamNeedUpdateTimeoutID)
        clearTimeout(linkInstance.onStreamNeedUpdateTimeoutID)

    linkInstance.StreamNeedUpdateDate = Date.now() + UPDATE_LIVE_TIMEOUT_MS;
    const updateDate = startStreamUpdate && cacheItem.streamStartDateTimeString ? new Date(cacheItem.streamStartDateTimeString) : linkInstance.StreamNeedUpdateDate;
    if (!updateDate)
        return;
    const streamNeedUpdateAfterMS = Math.abs(updateDate - Date.now());

    linkInstance.onStreamNeedUpdateTimeoutID = setTimeout(() =>
    {
        linkInstance.onStreamNeedUpdateTimeoutID = null;
        linkInstance.onStreamNeedUpdate.Raise(linkInstance);

        if (eventOnUpdate)
            eventOnUpdate(linkInstance)
    }, streamNeedUpdateAfterMS);
}

ExternalLink.IsYouTubeLink = function (link)      
{
    return link && link.externalResource == ExternalLink.ExternalLinkType.YOUTUBE_LINK;
}

ExternalLink.AccountType = {
    0: 'LIVE',
    1: 'DEMO',
    LIVE: 'LIVE',
    DEMO: 'DEMO'
}

ExternalLink.ExternalLinkType = {
    UNKNOWN: -1,
    NONE: 0,
    LINK_TOKEN_LANG: 1,
    TRADING_CENTRAL: 2,
    AUTOCHARTIST_RP: 3,
    AUTOCHARTIST_IFRAME: 4,
    ITCHART_ADVANCED: 5,
    YOUTUBE_LINK: 6,        //#114288
}